export function getNonce() {
  // read the property, not the attribute: browsers hide the nonce attribute value from the DOM
  const element = document.querySelector<HTMLMetaElement>('meta[property="csp-nonce"]')
  return element?.nonce ?? ''
}
